export const validWebsiteRegEx =
  /^((ftp|http|https):\/\/)?(www.)?(?!.*(http|https))[.a-zA-Z0-9_-]+(\.[a-zA-Z-]+)+((\/)[\w#!./?_&=,'+:%()@~-]+)*(\/\w+\?[.a-zA-Z0-9_-]+=\w+(&[.a-zA-Z0-9_-]+=\w+)*)?(\/)?$/m;
